module.exports = __webpack_public_path__ + "img/9.32a8ba80.jpg";